import request from "root/js/request";

export const getPromoPartnerInfo = async id => {
  const response = await request({
    url: `/promo_partners/${id}`,
    method: "get",
  });
  return response.data;
};
